export enum MediaPurpose {
  General = 'GENERAL',
  SupportTicket = 'SUPPORT_TICKET',
}
